// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"09010d97","453":"2f57f6c8","455":"f0a58aac"}[chunkId] + ".chunk.js";
};